const transformAnswers = (answers) => {
  if (answers == null ? void 0 : answers.length) {
    return answers.map((answer) => ({
      value: answer.answerId,
      label: (answer == null ? void 0 : answer.description) || "N/A"
    }));
  }
  return [];
};
export {
  transformAnswers
};
